/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Button, Menu, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { DropdownMLStyled } from './DropdownMLStyled';

/**
 * 头部OK按钮
 * @param {*} param
 */
const DropdownML = ({
  // onClick,
  title,
  width = 'auto',
  height = 'auto',
  fontsize = '16px',
  // menuClick,
  item,
  index,
  clickButton,
  menu,
  disabled,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  const onclick = (e) => {
    e.preventDefault();
    clickButton(item, index);
  };

  return (
    <DropdownMLStyled
      theme={themeContext}
      width={width}
      height={height}
      fontsize={fontsize}
      brand={brandContext}
    >
      <Dropdown overlay={menu} trigger={['click']} disabled={disabled}>
        <Button onClick={onclick}>
          {title}
          <DownOutlined />
        </Button>
      </Dropdown>
    </DropdownMLStyled>
  );
};

export default DropdownML;
